import type { CreatorEntity } from "shared/schema";
import type { AtTagData } from "shared/util/tag";
import { EntityButton } from "../entity/EntityButton.js";
import { useShortcutItem, useUsernameItem } from "../util/data.js";

export function AtTagButton({ username, slug }: AtTagData): React.ReactElement {
	const { creator } = useUsernameItem(username).data;
	return slug ? <ShortcutButton creator={creator} slug={slug} /> : <EntityButton entity={creator} />;
}

function ShortcutButton({ creator, slug }: { creator: CreatorEntity; slug: string }): React.ReactElement {
	const { target } = useShortcutItem(creator, slug).data;
	return <EntityButton entity={target} />;
}
